import { matchPath } from 'react-router';
import { useLocation } from 'react-router-dom';

export default function useParams(path) {
  const { pathname } = useLocation();
  const match = matchPath(pathname, { path });
  return match?.params || {};
}